import { getVapidKey, subscribePush, unsubscribePush } from '../api/push';
import { buildUserIdPayload } from './userIdPayload';

/**
 * Проверка доступности Push API в браузере.
 */
export function isPushSupported() {
    return (
        typeof navigator !== 'undefined' &&
        'serviceWorker' in navigator &&
        'PushManager' in window &&
        'Notification' in window
    );
}

/**
 * Конвертация base64url (VAPID key) в Uint8Array для pushManager.subscribe().
 */
export function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * Полный флоу подписки на push после авторизации.
 * Вызывать в фоне (без await), без показа ошибок пользователю.
 * @param {string} userId - идентификатор пользователя (tg_id)
 */
export async function subscribeToPush(platform, userId) {
    // if (!isPushSupported()) return;
    try {
        const permission = await Notification?.requestPermission?.();


        if (permission !== 'granted') return;

        const { publicKey } = await getVapidKey();
        if (!publicKey) return;

        const applicationServerKey = urlBase64ToUint8Array(publicKey);

        const registration = await navigator?.serviceWorker?.ready;

        const subscription = await registration?.pushManager?.subscribe({
            userVisibleOnly: true,
            applicationServerKey,
        });

        const endpoint = subscription?.endpoint;

        const keys = subscription?.getKey('p256dh');

        const auth = subscription?.getKey('auth');

        const p256dh = keys
            ? btoa(String.fromCharCode.apply(null, new Uint8Array(keys)))
            : '';

        const authBase64 = auth
            ? btoa(String.fromCharCode.apply(null, new Uint8Array(auth)))
            : '';

        const device_name =
            typeof navigator !== 'undefined' && navigator?.userAgent
                ? navigator?.userAgent?.slice(0, 500)
                : 'unknown';


        const response = await subscribePush({
            ...buildUserIdPayload(platform, String(userId)),
            endpoint,
            keys: { p256dh: p256dh, auth: authBase64 },
            expirationTime: subscription?.expirationTime ?? null,
            device_name,
        });
    } catch (error) {
        // Не показываем ошибки пользователю
        console.log('subscribeToPush error', error);
    }
}

/**
 * Отписка от push (удаление подписки в браузере и на бэкенде).
 * Вызывать при выходе из аккаунта.
 */
export async function unsubscribeFromPush() {
    // if (!isPushSupported()) return;
    try {
        const registration = await navigator?.serviceWorker?.ready;
        const subscription = await registration?.pushManager?.getSubscription();
        if (subscription) {
            await subscription?.unsubscribe();
            await unsubscribePush({ endpoint: subscription?.endpoint });
        }
    } catch (error) {
        console.log('unsubscribeFromPush error', error);
        // Не показываем ошибки пользователю
    }
}
